import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFeatureSuggestionsQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
  genomeId: Types.InputMaybe<Types.Scalars['Long']['input']>;
  types: Types.InputMaybe<Array<Types.InputSearchEntityTypeInput> | Types.InputSearchEntityTypeInput>;
}>;


export type GetFeatureSuggestionsQuery = { search: { globalSearch: { searchTerm: string | null, categories: Array<{ totalItemCount: number | null, subTypeId: number | null, categoryType: string | null, categoryName: string | null, items: Array<{ id: number | null, name: string | null, subTypeId: number | null, region: { strand: string | null, contig: { id: number, name: string | null, accession: string, sequenceId: string, version: number, length: number, groupType: string, organism: { id: number, name: string | null, description: string | null } } | null, range: { start: number, stop: number } | null } | null } | null> | null } | null> | null } | null } };


export const GetFeatureSuggestionsDocument = gql`
    query getFeatureSuggestions($searchTerm: String!, $genomeId: Long, $types: [InputSearchEntityTypeInput!]) {
  search {
    globalSearch(searchTerm: $searchTerm, genomeId: $genomeId, types: $types) {
      searchTerm
      categories {
        totalItemCount
        subTypeId
        categoryType
        categoryName
        items {
          id
          name
          subTypeId
          region {
            strand
            contig {
              id
              name
              accession
              sequenceId
              version
              length
              groupType
              organism {
                id
                name
                description
              }
            }
            range {
              start
              stop
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeatureSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetFeatureSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureSuggestionsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      genomeId: // value for 'genomeId'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetFeatureSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureSuggestionsQuery, GetFeatureSuggestionsQueryVariables> & ({ variables: GetFeatureSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureSuggestionsQuery, GetFeatureSuggestionsQueryVariables>(GetFeatureSuggestionsDocument, options);
      }
export function useGetFeatureSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureSuggestionsQuery, GetFeatureSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureSuggestionsQuery, GetFeatureSuggestionsQueryVariables>(GetFeatureSuggestionsDocument, options);
        }
export function useGetFeatureSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeatureSuggestionsQuery, GetFeatureSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureSuggestionsQuery, GetFeatureSuggestionsQueryVariables>(GetFeatureSuggestionsDocument, options);
        }
export type GetFeatureSuggestionsQueryHookResult = ReturnType<typeof useGetFeatureSuggestionsQuery>;
export type GetFeatureSuggestionsLazyQueryHookResult = ReturnType<typeof useGetFeatureSuggestionsLazyQuery>;
export type GetFeatureSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetFeatureSuggestionsSuspenseQuery>;
export type GetFeatureSuggestionsQueryResult = Apollo.QueryResult<GetFeatureSuggestionsQuery, GetFeatureSuggestionsQueryVariables>;